export default "__VITE_ASSET__568c8742__"